import { MutationHookOptions, useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { EJourneyGameBadgeType } from '../../utils/journeysUtils';

// GraphQL mutation
const UPSERT_EARNED_BADGE_MUTATION = gql`
  mutation upsertEarnedBadge($id: String!, $badge: EarnedBadgeInput!) {
    upsertEarnedBadge(id: $id, badge: $badge) {
      _id
      userId
      gameType
      earnedBadges {
        type
        value
        earnedAt
      }
    }
  }
`;

// Input types for TypeScript
export interface EarnedBadgeInputType {
  type: EJourneyGameBadgeType;
  value?: string;
  earnedAt: string; // ISO string
}

export interface UpsertEarnedBadgeMutationType {
  upsertEarnedBadge: {
    _id: string;
    userId: string;
    gameType: string;
    earnedBadges: {
      type: EJourneyGameBadgeType;
      value?: string;
      earnedAt: string;
    }[];
  };
}

export interface UpsertEarnedBadgeMutationVariables {
  id: string; // JourneyGameBadges _id
  badge: EarnedBadgeInputType;
}

// Custom hook
export function useUpsertEarnedBadgeMutation(
  options?: MutationHookOptions<UpsertEarnedBadgeMutationType, UpsertEarnedBadgeMutationVariables>,
) {
  return useMutation<UpsertEarnedBadgeMutationType, UpsertEarnedBadgeMutationVariables>(
    UPSERT_EARNED_BADGE_MUTATION,
    options,
  );
}
